import React, { Component } from 'react';
 const MAX_LENGTH_observacion = 40;
class getNota extends Component {
  eliminarPreferencia =(uuid_transaccion)=>{
    this.props.props_set_delete_preferencias(uuid_transaccion)
  }
  /*<div className="grid-container-items" key={index} >
          <div className="lbl_cantidad-items">
          1x</div>
          <div className="lbl_restar-items" >
          <img style={{"width":"20px","height":"20px"}} onClick={ () => this.eliminarPreferencia(index)}
          className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128 (1).png') }  />
          </div>
          <div className="lbl_precio-items">${Number(ditem.precio_adicional)+Number(precio_venta)}</div>
          <div className="lbl_sumar-items">
          <img style={{"width":"20px","height":"20px"}} onClick={ () => this.props.editarPreferencia(ditem.id_producto_combo,index,precio_venta,sw_iva)}
          className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') }  />
          </div>
          <div className="span-global-title-producto">{component}</div>
          <div className="lbl_descripcion-items">{descripcion} 
            {
                this.getDescripcionPreferencia(ditem)
            }</div>
          <div className="lbl-imagen-items">
            <img style={{"width":"60px","height":"60px","borderRadius": "20%"}} className="icon-global" alt="Cargando Imagen . . ."
             src={
               ((uuid_imagen+'').trim()==='')?
                 "https://www.grupomn.net/app/img/sinfoto.png"
               :
                 token_image+uuid_imagen+ext
               }/>
          </div>
        </div>*/
  getDetallePreferencia=(index,precio_venta,component,descripcion,token_image,uuid_imagen,ext,sw_iva,uuid_transaccion)=>{
    const lista_items_adicional = this.props.lista_items_adicional.filter(
      lista_items_adicional => lista_items_adicional.uuid_transaccion === uuid_transaccion
    )
    //console.log("-")
    //console.log(this.props.items_cantidad)
    return (
      <React.Fragment>
      {lista_items_adicional.map((ditem , index) => (
        <React.Fragment key={index}>
        <div className="cssversion_pw100 cssversion_pxh110 borderBottom" style={{"borderRadius": "25px 0px 25px 0px","margin-top": "10px"}} >
          <div className="cssversion_pw100 cssversion_pxh90" style={{"display":"flex"}}>
            <div className="cssversion_pw10 cssversion_pxh90">
              <div className="cssversion_pw100 cssversion_pxh30 cssversion_contentCenter"  style={{"display":"flex"}} >
                <span className="span-global-title-cantidad">
                    {"1x"}
                  </span>
              </div>
              <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} onClick={ () => this.eliminarPreferencia(uuid_transaccion)} >
                <img style={{"width":"20px","height":"20px"}}  className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128 (1).png') }  />
              </div>
            </div>
            <div className="cssversion_pw20 cssversion_pxh90 cssversion_contentCenter"  style={{"display":"flex"}} >
              <img style={{"width":"60px","height":"60px","borderRadius": "20%"}} alt="Cargando Imagen . . ."
                src={
                ((uuid_imagen+'').trim()==='')?
                  "https://www.grupomn.net/app/img/sinfoto.png"
                :
                  token_image+uuid_imagen+ext
                }/>
            </div>
            <div className="cssversion_pw55 cssversion_pxh90">
              <div className="cssversion_pw100 cssversion_pxh30 cssversion_contentCenter"  style={{"display":"flex"}} >
                <span className="span-global-title-producto" style={{"fontSize":"9pt"}}>{component}</span>
              </div>
              <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} >
                <span className="span-global-title-descripcion" style={{"fontSize":"8pt"}}>{descripcion}{
                    this.getDescripcionPreferencia(ditem)
                }</span>
              </div>
            </div>
            <div className="cssversion_pw15 cssversion_pxh90">
              <div className="cssversion_pw100 cssversion_pxh30 cssversion_contentCenter"  style={{"display":"flex"}} >
                <span className="span-global-title-cantidad">${Number(ditem.precio_adicional)+Number(precio_venta)}</span>
              </div>
              <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}}  >
                <img style={{"width":"20px","height":"20px"}} onClick={ () => this.props.editarPreferencia(ditem.id_producto_combo,index,precio_venta,sw_iva,ditem.uuid_transaccion)}
          className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/15586770221582004499-128.png') }  />
              </div>
            </div>
          </div>
            <div className="cssversion_pw100">
            <input value={this.props.items_observaciones[ditem.uuid_transaccion]} onChange={(event)=>this.inputChangedHandlerText1(event,ditem.uuid_transaccion)} className="input-global-v2 cssversion_pw90" placeholder="Añadir una nota (más salsa, sin cebolla, etc.)" />
            <div style={{ fontSize: "12px", color: (this.props.items_observaciones[ditem.uuid_transaccion] || "").length === MAX_LENGTH_observacion ? "red" : "#555", textAlign: "right" }}>
              {(this.props.items_observaciones[ditem.uuid_transaccion] || "").length}/{MAX_LENGTH_observacion}
            </div>
            </div> 
        </div>
        </React.Fragment>
    ))}
    </React.Fragment>
    )
  }
  getDescripcionPreferencia=(ditem)=>{
    let descripcion = ''
    ditem.complemento_final.forEach(cp_detalle => {
        if(cp_detalle.complemento==='Combo'){
          cp_detalle.CDetalle.forEach(cp_detalle_combo => {
             if(descripcion!=='') descripcion = descripcion + ' + '
             descripcion = descripcion + cp_detalle_combo.cant + 'x '+ cp_detalle_combo.producto
          })
        }else{
          if(descripcion!=='') descripcion = descripcion + ' + '
          if(cp_detalle.complemento==='Adicional'){
            descripcion = descripcion  + cp_detalle.cant + 'x '+ cp_detalle.producto + ' ' + cp_detalle.precio + '$'
          }else{
            descripcion = descripcion +  cp_detalle.producto
          }
        }
    })
    return(
      <React.Fragment>
        {descripcion}
      </React.Fragment>
    )
  }
  mostrarItems = () => {

    const url_image = this.props.url_image// "https://firebasestorage.googleapis.com/v0/b/"
    const separator = this.props.separator//"/o/images%2F"
    const file_xxx =this.props.file_60x60
    const token_image = url_image+file_xxx+separator
    const ext="_60x60.png?alt=media"
    const items = this.props.lista_items
    if(items.length === 0) return null
    return (
       <React.Fragment>
         {items.map((item , index) => (
           <div key={index}>
              {item.Citems.map((ditem , dindex) => (
                <React.Fragment key={"key_item_"+ditem.uuid_transaccion}>
                <React.Fragment>
                {(this.props.items_cantidad[ditem.uuid_transaccion])? //{(this.props.items_cantidad[ditem.id])?
                  <React.Fragment>
                    <div className="cssversion_pw100 cssversion_pxh110 borderBottom" style={{"borderRadius": "25px 0px 25px 0px","margin-top":"10px"}} >
                      <div className="cssversion_pw100 cssversion_pxh90" style={{"display":"flex"}}>
                        <div className="cssversion_pw10 cssversion_pxh90">
                          <div className="cssversion_pw100 cssversion_pxh30 cssversion_contentCenter"  style={{"display":"flex"}} >
                            {(this.props.items_cantidad[ditem.uuid_transaccion])?
                              <span className="span-global-title-cantidad">
                                {this.props.items_cantidad[ditem.uuid_transaccion]+"x"}
                              </span>
                              :
                              ""
                            }
                          </div>
                          <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} onClick={ () => this.eliminarCantidad(ditem.uuid_transaccion)} >
                            {(this.props.items_cantidad[ditem.uuid_transaccion])?
                            <img style={{"width":"20px","height":"20px"}}  className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128 (1).png') }  />
                            :''}
                          </div>
                        </div>
                        <div className="cssversion_pw20 cssversion_pxh90 cssversion_contentCenter"  style={{"display":"flex"}} >
                          <img style={{"width":"60px","height":"60px","borderRadius": "20%"}} alt="Cargando Imagen . . ."
                           src={
                           ((ditem.uuid_imagen+'').trim()==='')?
                             "https://www.grupomn.net/app/img/sinfoto.png"
                           :
                             token_image+ditem.uuid_imagen+ext
                           }/>
                        </div>
                        <div className="cssversion_pw55 cssversion_pxh90">
                          <div className="cssversion_pw100 cssversion_pxh30 cssversion_contentCenter"  style={{"display":"flex"}} >
                            <span className="span-global-title-producto" style={{"fontSize":"9pt"}}>{ditem.component}</span>
                          </div>
                          <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}} >
                            <span className="span-global-title-descripcion" style={{"fontSize":"8pt"}}>{ditem.descripcion}</span>
                          </div>
                        </div>
                        <div className="cssversion_pw15 cssversion_pxh90">
                          <div className="cssversion_pw100 cssversion_pxh30 cssversion_contentCenter"  style={{"display":"flex"}} >
                            <span className="span-global-title-cantidad">${ditem.precio_venta}</span>
                          </div>
                          <div className="cssversion_pw100 cssversion_pxh60 cssversion_contentCenter"  style={{"display":"flex"}}  >
                          </div>
                        </div>
                      </div>
                      {(this.props.items_cantidad[ditem.uuid_transaccion])?
                      <div className="cssversion_pw100">
                      <input value={this.props.items_observaciones[ditem.uuid_transaccion]} onChange={(event)=>this.inputChangedHandlerText1(event,ditem.uuid_transaccion)} className="input-global-v2 cssversion_pw90" placeholder="Añadir una nota (más salsa, sin cebolla, etc.)" />
                      <div style={{ fontSize: "12px", color: (this.props.items_observaciones[ditem.uuid_transaccion] || "").length === MAX_LENGTH_observacion ? "red" : "#555", textAlign: "right" }}>
                        {(this.props.items_observaciones[ditem.uuid_transaccion] || "").length}/{MAX_LENGTH_observacion}
                      </div>
                      </div>
                      :''}
                    </div>
                  </React.Fragment>
                :''}
                </React.Fragment>
              {
                this.getDetallePreferencia(ditem.id,ditem.precio_venta,ditem.component,ditem.descripcion,
                  token_image,ditem.uuid_imagen,ext,ditem.sw_iva,ditem.uuid_transaccion)
              }
              </React.Fragment>
              ))}
           </div>
         ) ) }
       </React.Fragment>
     )
   }
   /*
onClick={ () => this.agregarCantidad(ditem.id,ditem.combo,ditem.precio_venta,ditem.sw_iva) }


   <React.Fragment key={dindex}>
     <React.Fragment>
     {(this.props.items_cantidad[ditem.id])?
       <React.Fragment>
         <div className="grid-container-items" >
           <div className="lbl_cantidad-items">
           {(this.props.items_cantidad[ditem.id])?this.props.items_cantidad[ditem.id]+"x":""}</div>
           <div className="lbl_restar-items" >
           {(this.props.items_cantidad[ditem.id])?
           <img style={{"width":"20px","height":"20px"}} onClick={ () => this.eliminarCantidad(ditem.id)} className="icon-global" alt="Cargando Imagen . . ." src={ require('../image/12355707351582004488-128 (1).png') }  />
           :''}
           </div>
           <div className="lbl_precio-items">${ditem.precio_venta}</div>
           <div className="lbl_sumar-items" ></div>
           <div className="lbl_item-items">{ditem.component}</div>
           <div className="lbl_descripcion-items">{ditem.descripcion}</div>
           <div className="lbl-imagen-items">
             <img style={{"width":"60px","height":"60px","borderRadius": "20%"}} className="icon-global" alt="Cargando Imagen . . ."
              src={
                ((ditem.uuid_imagen+'').trim()==='')?
                  "https://www.grupomn.net/app/img/sinfoto.png"
                :
                  token_image+ditem.uuid_imagen+ext
                }/>
           </div>
         </div>
       </React.Fragment>
     :''}
     </React.Fragment>
    {
     this.getDetallePreferencia(ditem.id,ditem.precio_venta,ditem.component,ditem.descripcion,
       token_image,ditem.uuid_imagen,ext,ditem.sw_iva)
   }
   </React.Fragment>*/

   inputChangedHandlerText1 =(event,uuid_transaccion)=>{
     if (event.target.value.length <= MAX_LENGTH_observacion) {
      var items_observaciones = this.props.items_observaciones;//.slice();
      items_observaciones[uuid_transaccion] = event.target.value;      
      this.props.props_set_observacion(items_observaciones)
      //console.log(items_observaciones)
     }
   }
   eliminarCantidad =(uuid_transaccion)=>{

    let lista_items_temp =this.props.items_cantidad
    if((lista_items_temp[uuid_transaccion])){
      lista_items_temp[uuid_transaccion] = Number(lista_items_temp[uuid_transaccion]) - 1;
       if(lista_items_temp[uuid_transaccion]<=0){
        lista_items_temp[uuid_transaccion] = "";
       }
    }
    /*  var items_cantidad = this.props.items_cantidad.slice();
     if(isNaN(items_cantidad[uuid_transaccion])){
       items_cantidad[uuid_transaccion] = "";
     }else{
       items_cantidad[uuid_transaccion] = Number(items_cantidad[uuid_transaccion]) - 1;
       if(items_cantidad[uuid_transaccion]<=0){
         items_cantidad[uuid_transaccion] = "";
       }
     } */


     this.props.props_set_cantidad(lista_items_temp)
   }
  render () {
     return (
       <React.Fragment>
       {this.mostrarItems()}
       </React.Fragment>
     )
  }

}
export default getNota;
